
import Vue from 'vue'
import * as Api from '@/api/StorePaymentApi'
import { PaymentDto } from '@ViewModels/PaymentDto'
import { Alert } from '@/components'
import Header from './components/Header.vue'
import ProcessingBanner from './components/ProcessingBanner.vue'
import InvoiceSection from './components/InvoiceSection.vue'
import PaymentSection from './components/PaymentSection.vue'
import SuccessSection from './components/SuccessSection.vue'

export default Vue.extend({
   name: 'PaymentPage',
   data() {
      return {
         loading: true,
         continued: false,
         submitted: false,
         processing: false,
         success: false,
         errorMessage: '',
         paymentId: '',
         displayData: {
            currencyCode: 'NZD',
            currencySymbol: '$',
            brandName: '',
         },
         data: {
            InvoiceNumber: '',
            CustomerNumber: '',
            PaymentAmount: 0,
            CardNumber: '',
            NameOnCard: '',
            CardExpiryMonth: 0,
            CardExpiryYear: 0,
            CardCvc: '',
            CurrencyId: '',
            MarketId: '',
            RecaptchaToken: '',
         } as PaymentDto,
      }
   },
   computed: {},
   mounted() {
      this.loadModelData()
      this.loadDefaultsFromQueryString()
   },
   methods: {
      async loadModelData() {
         const modelData = await Api.getModelData()
         this.data.CurrencyId = modelData.CurrencyId
         this.data.MarketId = modelData.MarketId
         this.displayData.currencyCode = modelData.CurrencyCode
         this.displayData.currencySymbol = modelData.CurrencySymbol
         this.displayData.brandName = modelData.BrandName
         this.loading = false
      },
      async loadDefaultsFromQueryString() {
         if (this.$route.query.amount) {
            this.data.PaymentAmount = +this.$route.query.amount
         }
         if (this.$route.query.account) {
            this.data.CustomerNumber = this.$route.query.account.toString()
         }
         if (this.$route.query.documentno) {
            this.data.InvoiceNumber = this.$route.query.documentno.toString()
         }
      },
      recordRecaptchaToken(token: string) {
         this.data.RecaptchaToken = token
      },
      async continueToPayment() {
         this.continued = true
      },
      async processPayment() {
         this.submitted = true
         try {
            this.processing = true
            const result = await Api.makePayment(this.data)
            if (result.HasError) {
               this.errorMessage = result.ErrorMessage
                  ? result.ErrorMessage
                  : 'Please check your information and try again.'
               this.processing = false
            } else {
               this.processing = false
               this.paymentId = result.CommittedId
               this.success = true
            }
         } catch (err) {
            this.processing = false
            this.errorMessage = err.message
         }
      },
   },
   components: {
      Header,
      ProcessingBanner,
      InvoiceSection,
      PaymentSection,
      SuccessSection,
      Alert,
   },
})
